import * as THREE from 'three'
import EventDispatcher from '../common/EventDispatcher'
import {
    Global
} from '../common/global';
import {
    GLTFLoader
} from 'three/examples/jsm/loaders/GLTFLoader';
import {
    getPreloadImage,
    preloadImage
} from '../common/preload';
import {
    DRACOLoader
} from 'three/examples/jsm/loaders/DRACOLoader.js'
import {
    MeshoptDecoder
} from 'three/examples/jsm/libs/meshopt_decoder.module.js';


const ASSET_TYPES = {
    TEXTURES: 'textures',
    CUBEMAP: 'cubemap',
    GLBS: 'glbs',
    SOUNDS: 'sounds',
};

const EVENT_TYPES = {
    LOAD_COMPLETE: 'load_complete',
    ADD_SKY: 'add_sky',
};

export default class AssetLoader {
    constructor(scene) {
        this.scene = scene;
    }

    init() {
        this.events = EventDispatcher.getObj();
        this.baseURL = '';

        this.loadingMgr = new THREE.LoadingManager(
            () => {
                this.events.dispatchEvent({
                    type: "LOADER_EVENTS",
                    message: {
                        "event_type": EVENT_TYPES.LOAD_COMPLETE,
                        data: {}
                    }
                });
                this.events.dispatchEvent({
                    type: "GAMESCENE_EVENTS",
                    message: {
                        "event_type": EVENT_TYPES.ADD_SKY,
                        data: {}
                    }
                });
            }
        );
        this.loadingMgr.onProgress = function (url, itemsLoaded, itemsTotal) {
            var progress = itemsLoaded / itemsTotal;
            document.querySelector('.loading_progress .progress').style.transform = `translateX(${-100+progress*100}%)`
        };

        this.textureLoader = new THREE.TextureLoader(this.loadingMgr);
        this.textureLoader.setPath(this.baseURL);

        this.audioLoader = new THREE.AudioLoader(this.loadingMgr);
        this.audioLoader.setPath(this.baseURL);

        this.cubeTextureLoader = new THREE.CubeTextureLoader(this.loadingMgr);
        this.cubeTextureLoader.setPath(this.baseURL);


        const dracoLoader = new DRACOLoader()
        dracoLoader.setDecoderPath('/draco/')

        this.gltfLoader = new GLTFLoader(this.loadingMgr);
        this.gltfLoader.setDRACOLoader(dracoLoader)
        this.gltfLoader.setMeshoptDecoder(MeshoptDecoder);

    }
    prepare() {
        this.events.dispatchEvent({
            type: "GAMESCENE_EVENTS",
            message: {
                "event_type": "show_splash",
                data: {}
            }
        });

        this.load();
    }

    load() {
        let assetsToLoad = Global.assets;
        Object.keys(assetsToLoad).forEach((typeKey) => {
            let itemKeys = Object.keys(assetsToLoad[typeKey]);
            itemKeys.forEach((itemKey) => {
                if (typeKey === ASSET_TYPES.TEXTURES) {
                    this[assetsToLoad[typeKey][itemKey]['key']] = this.textureLoader.load(assetsToLoad[typeKey][itemKey]['path']);
                    Global.assets[typeKey][itemKey]['asset'] = this[assetsToLoad[typeKey][itemKey]['key']];
                }
                if (typeKey === ASSET_TYPES.CUBEMAP) {
                    this[assetsToLoad[typeKey][itemKey]['key']] = this.cubeTextureLoader.load(assetsToLoad[typeKey][itemKey]['path']);
                    Global.assets[typeKey][itemKey]['asset'] = this[assetsToLoad[typeKey][itemKey]['key']];
                }
                if (typeKey === ASSET_TYPES.GLBS) {
                    this[assetsToLoad[typeKey][itemKey]['key']] = this.gltfLoader.load(assetsToLoad[typeKey][itemKey]['path'][0], (gltf) => {
                        Global.assets[typeKey][itemKey]['asset'] = gltf;
                    });
                }
                if (typeKey === ASSET_TYPES.SOUNDS) {
                    this[assetsToLoad[typeKey][itemKey]['key']] = this.audioLoader.load(assetsToLoad[typeKey][itemKey]['path'][0], (sound) => {
                        Global.assets[typeKey][itemKey]['asset'] = sound;
                    });
                }
            });
        });
    }
}